import { atom, RecoilState } from "recoil";
import { recoilPersist } from "recoil-persist";
import { EEScorecard } from "../Component/Model/Dto/EmploymentEquity/EEScorecard";
import { getDateWithoutTime } from "../Helpers/DateFormatter";


const { persistAtom } = recoilPersist();
export const EEScorecardAtom: RecoilState<EEScorecard.Atom> = atom<EEScorecard.Atom>({
    key: 'EEScorecardAtom', 
    default: {
        ScorecardName: '',
        YearReportIsSubmitted: 0,
        AppliedEapPercentage: 0,
        AppliedSectoralPercentage: 0,
        ApplicableSectoralTargetYear: 0,
        ReportPeriodDateFrom: getDateWithoutTime(new Date()),
        ReportPeriodDateTo: getDateWithoutTime(new Date()),
        EEPlanDateFrom: getDateWithoutTime(new Date()),
        EEPlanDateTo: getDateWithoutTime(new Date()),
        DTIRegistrationName:'',
        BusinessTypeId: 0,
        NumberOfEmployeesId: 0,
        IsOrganOfState: false,
        IsGroup: false,
        IsPostalSameAsPhysical: false
    } as EEScorecard.Atom,
    effects_UNSTABLE : [persistAtom]
});